/**
 * Страница настроек (смена пароля).
 * Доступна для любой роли.
 */

import React, { useState } from 'react';
import { authAPI } from '../../api/client';

const SettingsPage: React.FC = () => {
  const [form, setForm] = useState({ current: '', newPass: '', confirm: '' });
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage('');

    if (form.newPass !== form.confirm) {
      setMessage('Новый пароль и подтверждение не совпадают');
      return;
    }

    try {
      await authAPI.changePassword(form.current, form.newPass);
      setMessage('Пароль успешно изменён');
      setForm({ current: '', newPass: '', confirm: '' });
    } catch (err: any) {
      setMessage(err.response?.data?.error || 'Ошибка смены пароля');
    }
  };

  return (
    <div>
      <h1 style={{ marginBottom: 24 }}>Настройки</h1>

      <div style={styles.card}>
        <h3 style={{ marginTop: 0, marginBottom: 16 }}>Смена пароля</h3>

        {message && (
          <div style={{
            padding: '10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 14,
            backgroundColor: message.includes('изменён') ? '#f0fdf4' : '#fef2f2',
            color: message.includes('изменён') ? '#166534' : '#dc2626',
          }}>
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 400 }}>
          <input
            type="password" placeholder="Текущий пароль" required
            value={form.current}
            onChange={(e) => setForm({ ...form, current: e.target.value })}
            style={styles.input}
          />
          <input
            type="password" placeholder="Новый пароль (мин. 8, A-Z, a-z, 0-9)" required
            value={form.newPass}
            onChange={(e) => setForm({ ...form, newPass: e.target.value })}
            style={styles.input}
          />
          <input
            type="password" placeholder="Подтвердите новый пароль" required
            value={form.confirm}
            onChange={(e) => setForm({ ...form, confirm: e.target.value })}
            style={styles.input}
          />
          <button type="submit" style={styles.btn}>Сменить пароль</button>
        </form>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  card: {
    backgroundColor: 'var(--bg-card)', padding: 24, borderRadius: 12,
    boxShadow: 'var(--shadow-card)',
  },
  input: {
    padding: '10px 14px', border: '1px solid var(--border-color)',
    borderRadius: 8, fontSize: 14,
  },
  btn: {
    backgroundColor: '#2563eb', color: '#fff', border: 'none',
    padding: '10px 24px', borderRadius: 8, cursor: 'pointer',
    fontSize: 14, fontWeight: 600,
  },
};

export default SettingsPage;
